import * as React from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'

type Props = {
  cancel: () => void
}

export function ConditionsActions(props: Props) {
  const { cancel } = props

  return (
    <DialogActions sx={{ p: 0 }}>
      <Button onClick={cancel} sx={{ color: '#19305A' }} size="large">
        Cancel
      </Button>
      <Button
        variant="contained"
        size="large"
        type="submit"
        sx={{ background: '#19305A' }}
      >
        Save
      </Button>
    </DialogActions>
  )
}
